document.addEventListener('DOMContentLoaded', function () {
  //Select field dropdown arrow on fluent forms
  var selectElements = document.querySelectorAll("select");

  if (selectElements) {
    selectElements.forEach(function (selectElement) {
      if (selectElement.parentElement.classList.contains("ff-el-input--content")) {
        selectElement.parentElement.classList.add("relative");
        selectElement.parentElement.innerHTML += "<i class='icon-caret-down absolute text-black'></i>";
      }
    });
  } //adding wrapper around tables to style nicer responsively


  var tables = document.querySelectorAll("table");

  if (tables) {
    tables.forEach(function (table) {
      var tableForm = table.closest("form");
      if (table.classList.contains("shop_table") || table.classList.contains("variations") || table.classList.contains("evdb-quick-stats") || tableForm && tableForm.hasAttribute('id') && tableForm.id == "cc-settings") return;
      var tableContainer = document.createElement("div");
      table.parentNode.insertBefore(tableContainer, table);
      tableContainer.appendChild(table);
      tableContainer.classList.add("w-full", "overflow-x-auto");
    });
  }
}); // YouTube consent facade
// Shows a thumbnail placeholder over Cookiebot-blocked iframes.
// Clicking the play button opens the consent dialog if not yet accepted,
// or reveals the video if marketing cookies are already allowed.

document.addEventListener('DOMContentLoaded', function () {
  var _window$Cookiebot, _window$Cookiebot$con;

  var wrappers = document.querySelectorAll('.yt-consent-wrapper');
  if (!wrappers.length) return; // Returning visitor — consent already given before this page load

  if ((_window$Cookiebot = window.Cookiebot) !== null && _window$Cookiebot !== void 0 && (_window$Cookiebot$con = _window$Cookiebot.consent) !== null && _window$Cookiebot$con !== void 0 && _window$Cookiebot$con.marketing) {
    wrappers.forEach(function (w) {
      return w.classList.add('yt-loaded');
    });
  }
}); // Fired by Cookiebot after the user accepts cookies on this page load

window.addEventListener('CookiebotOnAccept', function () {
  var _window$Cookiebot2, _window$Cookiebot2$co;

  if ((_window$Cookiebot2 = window.Cookiebot) !== null && _window$Cookiebot2 !== void 0 && (_window$Cookiebot2$co = _window$Cookiebot2.consent) !== null && _window$Cookiebot2$co !== void 0 && _window$Cookiebot2$co.marketing) {
    document.querySelectorAll('.yt-consent-wrapper').forEach(function (w) {
      return w.classList.add('yt-loaded');
    });
  }
});